// Generic placeholder for nav items whose modules are not yet built
export default function PlaceholderPage({ title, description }) {
  return (
    <div className="animate-fade-in" data-testid={`placeholder-${title.toLowerCase().replace(/\s+/g, '-')}`}>
      <h1 className="font-semibold text-lg tracking-tight text-foreground">{title}</h1>
      <div className="mt-6 border border-border rounded bg-card p-4 max-w-xl">
        <p className="text-sm font-medium text-foreground">{title} module coming soon</p>
        <p className="text-sm text-muted-foreground mt-1">
          {description || `The ${title} module is not available yet. Check back soon.`}
        </p>
      </div>
    </div>
  );
}
